var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "box news-box" }, [
      _c(
        "div",
        { staticClass: "sub-nav" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                _vm._v("首页")
              ]),
              _vm._v(" "),
              _c("el-breadcrumb-item", [_vm._v("公告栏")])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "new-wrapper" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "right-box fr" }, [
          _c(
            "ul",
            _vm._l(_vm.tableData, function(item, index) {
              return _c(
                "li",
                {
                  key: index,
                  staticClass: "normal",
                  on: {
                    click: function($event) {
                      return _vm.handelTurnDetail(item)
                    }
                  }
                },
                [
                  _c("div", [
                    _c(
                      "span",
                      { staticClass: "fl", attrs: { title: item.title } },
                      [_vm._v(_vm._s(item.title))]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "fr" }, [
                      _vm._v(_vm._s(_vm._f("dateFormat")(item.publishTime)))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "clear" })
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "page" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.page.current,
                  "page-sizes": [10, 20, 50, 100, 500],
                  "page-size": _vm.page.size,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.page.total,
                  background: ""
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "clear" })
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left-box fl" }, [
      _c("div", { staticClass: "left-box-title" }, [
        _c("img", {
          staticStyle: { top: "14px" },
          attrs: {
            src: require("../../assets/images/notice-icon.png"),
            alt: ""
          }
        }),
        _vm._v("\n          公告栏\n          "),
        _c("img", {
          attrs: { src: require("../../assets/images/right.png"), alt: "" }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "left-box-content" }, [
        _c("img", {
          attrs: { src: require("../../assets/images/notice.png"), alt: "" }
        })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c66ca75", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c66ca75","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/notice/index.vue
// module id = null
// module chunks = 